import React, { Component } from "react";
import { injectIntl } from "react-intl";
import { getFM, getSpan } from "../../../Utilities/utils";
import BgGrid from "../../BgGrid";
import "./pScene9.css";
import Slider from "react-slick";
import SlideItem from "../../SlideItem";
import box1 from "../../../Resources/box-blog.jpeg";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { RArrowIcon } from "../../menu/MenuIcons";
import box2 from "../../../Resources/box-eterxperience.jpeg";
import box3 from "../../../Resources/box-playable-ads.jpeg";
import box4 from "../../../Resources/box-white-paper-thin.jpg";
import insight from "../../../Resources/imagen-background-contact.jpeg";
import insight2 from "../../../Resources/foto_contacto_enmascarada.jpg";
import { withRouter } from "react-router";
import Button360 from "../../../Resources/icons/360_button_normal.svg";
import MaxButton from "../../MaxButton";
import { logEvent } from "../../../Utilities/AmplitudeService";

class PScene9 extends Component {
  getFooter() {
    return (
      <div className={"circle t-circle"}>
        <RArrowIcon className={"b-arrow"} />
      </div>
    );
  }

  render() {
    let settings = {
      dots: false,
      infinite: false,
      speed: 600,
      slidesToScroll: 1,
      slidesToShow: 1,
      vertical: false,
      adaptiveHeight: true,
      arrows: false,
      centerMode: false,
      variableWidth: true,
    };
    return (
      <section className={"p-container"}>
        <div id={"pscene9"} className="content">
          <BgGrid className={"p-bg-grid"} id="p_s9bg" hLines={5} vLines={4} />
          <h1 className={"p-text-container-scene-9"}>
            <span className={"p-text"}>
              {getFM("phome_carrousel_title")}
              <br />
              {getSpan(["phome_carrousel_title_2"], "ps9-txt", " ")}
            </span>
          </h1>

          <div className={"carrousel"}>
            <Slider {...settings}>
              <SlideItem
                id={"p-blog-item"}
                title={["home_carrousel_blog_title"]}
                subTitle={[
                  "home_carrousel_blog_txt",
                  "home_carrousel_blog_txt_2",
                ]}
                bgImage={box1}
                clickable={true}
                footer={this.getFooter()}
                clickEvent={() => {
                  logEvent("news");
                  window.open(
                    this.props.intl.formatMessage({ id: "link_medium" }),
                    "_blank"
                  );
                }}
              />
              <SlideItem
                id={"p-360-item"}
                title={["eter_xperience"]}
                subTitle={[
                  "home_carrousel_360_txt",
                  "home_carrousel_360_txt_2",
                ]}
                bgImage={box2}
                clickable={true}
                footer={this.getFooter()}
                clickEvent={() =>
                  window.open("https://etermax.com/eterXperience")
                }
              >
                <img src={Button360} alt={"slide"} />
              </SlideItem>
              <SlideItem
                id={"p-showcase-item"}
                title={["home_carrousel_showcase_title"]}
                subTitle={[
                  "home_carrousel_showcase_txt",
                  "home_carrousel_showcase_txt_2",
                ]}
                clickable={true}
                bgImage={box3}
                footer={this.getFooter()}
                clickEvent={() => {
                  logEvent("showCase");
                  window.open("https://showcase.etermax.com");
                }}
              />
              <SlideItem
                id={"whitePaper-item"}
                title={[
                  "home_carrousel_whitePaper_title",
                  "home_carrousel_whitePaper_title1",
                  "home_carrousel_whitePaper_title2",
                  "home_carrousel_whitePaper_title3",
                ]}
                subTitle={[""]}
                clickable={true}
                bgImage={box4}
                footer={
                  <div style={{ width: "110%" }}>
                    <MaxButton id={"ps4b"} clickRoute={"big-events"}>
                      home_learn_more_button
                    </MaxButton>
                  </div>
                }
              />
              <SlideItem
                id={"p-insight-item"}
                className={"slide-item insightItem"}
                title={["home_carrousel_subscription_title"]}
                titleColor="#624CBF"
                subTitle={[
                  "home_carrousel_subscription_txt",
                  "home_carrousel_subscription_txt_2",
                ]}
                bgImage={insight2}
                clickable={true}
                clickEvent={() => {
                  logEvent("Subscribe");
                  this.props.history.push("/contact#subscribe");
                }}
                footer={this.getFooter()}
              />
            </Slider>
          </div>
        </div>
      </section>
    );
  }
}

export default withRouter(injectIntl(PScene9));
